"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var events_native_exports = {};
__export(events_native_exports, {
  subscribeNativeSourceEvent: () => subscribeNativeSourceEvent
});
module.exports = __toCommonJS(events_native_exports);
var import_react_native = require("react-native");
var import_index = require("./index.native");
var import_wire = require("./wire.native");
var emitter = new import_react_native.NativeEventEmitter(import_react_native.NativeModules.OneNativeSourceEvents);
function subscribeNativeSourceEvent(module2, event, listener, contractHash, payloadWires, structs) {
  if (typeof listener !== "function") {
    throw new TypeError(`native event ${module2}.${event} needs a listener function`);
  }
  var channel = `OneNativeSource.${module2}.${event}`;
  var subscription = emitter.addListener(channel, function(args) {
    listener(...(0, import_wire.decodeNativeSourceCallback)(args, payloadWires, structs, event));
  });
  (0, import_index.callNativeSource)(module2, event, [], contractHash);
  return function() {
    return subscription.remove();
  };
}
//# sourceMappingURL=events.native.js.map
